import React from "react";
import { useUserContext } from "@contexts/UserContext";
import { TaskListFilterService } from "../../../../../features/task-management/TaskListFilterService";
import useTaskData from "../../../../../features/task-management/useTaskData";
import { WidgetProps } from "../Widget";
import TaskListWidget from "./TaskListWidget";

export function FocusModeTaskListWidget(props: WidgetProps) {
    const { user } = useUserContext();
    const taskData = useTaskData({
        uid: user?.uid,
        filterService: TaskListFilterService(user?.uid),
    });

    return <TaskListWidget {...props} taskData={taskData} />;
}
